// extracted by mini-css-extract-plugin
module.exports = {"carbonCloud":"_1LWJIj","first":"_3P_h6F","last":"_1ckJzH","banner":"_3CcORG","svg":"_1vHcU1","text":"_2BQvOt","big_text":"JU4pQH"};